import React from 'react';
import { CallCenterProfile } from '../profileTypes';
import styles from './ProfileHeader.module.css';

interface ProfileHeaderProps {
  profile: CallCenterProfile;
}

export const ProfileHeader: React.FC<ProfileHeaderProps> = ({ profile }) => {
  return (
    <div className={styles.card}>
      <div className={styles.avatar}>
        <svg viewBox="0 0 24 24" fill="currentColor" className={styles.avatarIcon}>
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z" />
        </svg>
      </div>
      <div className={styles.info}>
        <h2 className={styles.staffName}>{profile.staffName}</h2>
        <p className={styles.role}>{profile.role}</p>
        <div className={styles.meta}>
          <span className={`${styles.statusBadge} ${styles[profile.status.toLowerCase()]}`}>
            {profile.status}
          </span>
          <span className={styles.metaItem}>Queue: {profile.queue}</span>
          <span className={styles.metaItem}>ID: {profile.staffId}</span>
        </div>
      </div>
    </div>
  );
};
